interface SvgInterface {
    className?: string;
    onClick?: () => void;
}
export function PlayIcon({className = '', onClick = () => {}}: SvgInterface) {
    return <svg onClick={onClick} className={className} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM372.5 276.5l-144 88C224.7 366.8 220.3 368 216 368c-13.69 0-24-11.2-24-24V168C192 155.3 202.2 144 216 144c4.344 0 8.678 1.176 12.51 3.516l144 88C379.6 239.9 384 247.6 384 256C384 264.4 379.6 272.1 372.5 276.5z"/>
    </svg>;
}